import { Box, Stack, styled, Typography, TypographyProps } from '@mui/material';
import { BlueberrySizeDataModel } from '../types';
import {
  decimalToRoundedPercentageString,
  getBucketTotal,
} from '../utils/getBucketTotal';
import { BlueberrySizeChartBarWithHover } from './BlueberrySizeChartBarWithHover';

const ChartLabelText = styled(Typography)<TypographyProps>(() => ({
  fontSize: '0.875rem',
  fontWeight: 600,
  lineHeight: '1.2425rem',
}));

export const BlueberrySizeChartRow = ({
  data,
  label,
  fullBarValue,
  totalMeasured,
}: {
  data: BlueberrySizeDataModel;
  label: string;
  fullBarValue: number;
  totalMeasured: number;
}) => {
  const bucketTotalCount = getBucketTotal(data);

  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
      justifyContent={'center'}
      gap={'1rem'}
    >
      <ChartLabelText flex={1} minWidth={'70px'}>
        {label}
      </ChartLabelText>
      <Box flex={8}>
        <BlueberrySizeChartBarWithHover
          data={data}
          fullBarValue={fullBarValue}
        />
      </Box>
      <ChartLabelText
        flex={1}
        textAlign={'right'}
        minWidth={'30px'}
        maxWidth={'50px'}
        sx={{
          fontWeight: 400,
          color: (theme) => theme.colors.canopy.text.secondary,
        }}
      >
        {decimalToRoundedPercentageString(bucketTotalCount / totalMeasured, 1)}
      </ChartLabelText>
      <ChartLabelText
        flex={1}
        textAlign={'right'}
        minWidth={'40px'}
        maxWidth={'70px'}
      >
        {bucketTotalCount.toLocaleString()}
      </ChartLabelText>
    </Stack>
  );
};
